import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_main_insert_ultraship_outbound_orders_to_stagingService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: {  }): Promise<void> 
  {
    let url = `${environment.backendUrl}api/Ultraship/functions/main_insert_ultraship_outbound_orders_to_staging`;
    
    const options = {
    }
    
    const body = null;
    
    return this.utils.http.post(url, body, options);
    
  }

}

